export const surveyInactiveMessage =
  'Die aufgerufene Umfrage wurde deaktiviert. Sie können leider nicht mehr an der Umfrage teilnehmen.';

export const serverStatusErrors: Record<number, string> = {
  1000: surveyInactiveMessage,
};
